import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EtobPopupComponent } from '../etob-popup/etob-popup.component';
import { ResumeLoadButton } from 'src/app/shared/common/resumeLoadButton';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { GenerateReport } from 'src/app/shared/common/GenerateReport';
import { constants } from 'src/app/shared/common/contants';
import { CommonTs } from 'src/app/shared/common/CommonTs';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { UserRoutingModule } from '../user-routing/user-routing.module';


@Component({
    selector: 'app-eto-bmigration',
    templateUrl: './eto-bmigration.component.html',
    styleUrls: ['./eto-bmigration.component.scss'],
    standalone: false
})
export class EtoBMigrationComponent implements OnInit {
  FormValid: UntypedFormGroup;
  backgroundColorButton = "";
  backgroundColorScreen = "";
  isCheckboxSelected:boolean = false;
  columnDefs;
  columnDefsE2B;
  defaultColDef;
  gridmgrnAPI;
  gridApi;
  gridmgrnData:any;
  rowSelectionForTablesFields;
  migrationParentId;
  tempextractparams:any;
  tempdata:any;
  tempmgrndata:any=[];
  statevaluechange={"fileName":"","fileData":""}
  imagephotoshow: any = false;
  imagephoto;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  pageSize;
  migrationType = "E2B";
  gridData:any;
  migrationData:any =[];
  tempmgrdata:any=[];
  migrationDataLoadLogObject: any = [];
  etoSTageFilePath: any = [];
  etoFTPPath: any =[];
  literatureSTageFilePath: any =[];
  literatureFTPPath:any =[];
  attachmentSTageFilePath:any =[];
  attachmentFTPPath: any =[];
  mgrstatus: any;
  filePath:any;
  mgrstartdt : any;
  mgrid: any;
  etobMigrationDetails={"e2bstageFiles":"", "literaturestageFiles":"", "attachmentstageFiles":"", "e2bftpPath":"", "literatureftpPath":"", "attachmentftpPath":""}
  attachmentmappingFile
  imageupload
  components:any;
  paginationPageSize
  rowSelection
  paginationNumberFormatter
  value
  temprunHistory:any;
  buttonIdList = []
  constructor(private commonTs:CommonTs,private localStorageSettings: LocalStorageSettingsService, private spinner: NgxUiLoaderService,private service:EtlService, private snackbar: MatSnackBar, private dialog: MatDialog, private constants: constants,
    private userRoutingModule: UserRoutingModule,private reportLinkService:ReportlinksserviceService) {
    this.components = {
      resumeLoadRenderer:ResumeLoadButton,
      downloadbuttonRenderer: FiledownloadComponent,
      gerateReportRenderer:GenerateReport,
    }
    
   }

  ngOnInit() {
     let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
    this.formvalidations();

    this.columnDefs = [
      {
        headerName: "Migration Id",
        headerTooltip: "Migration Id",
        tooltipValueGetter: params => "Migration Id : " + params.value,
        field: "migrationId",
        filter: "agTextColumnFilter",
        width: 120
      },
      {
        headerName: 'Start Date and Time',
        headerTooltip: 'Start Date and Time',
        tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
        field: 'startdt',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'End Date and Time',
        headerTooltip: 'End Date and Time',
        tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
        field: 'enddt',
        filter: 'agTextColumnFilter',
        width: 200
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        sort: "desc",
        width: 120
      },
      {
        headerName: 'Executed By',
        headerTooltip: 'Executed By',
        tooltipValueGetter: (params) => 'Executed By : ' + params.value,
        field: 'executedby',
        filter: 'agTextColumnFilter',
        width: 180
      },
      {
        headerName: 'Generate Summary Report', filter: false,
        cellRenderer: 'gerateReportRenderer',
        cellRendererParams: {
          generateReport: this.generateReport.bind(this),
          //delete: this.deleteIcon.bind(this),
        },
        width: 120
      },
      // added column in run history grid for comments
      {
        headerName: 'Description',
        headerTooltip: 'Description',
        tooltipValueGetter: (params) => 'Description : ' + params.value,
        field: 'comment',
        filter: 'agTextColumnFilter',
        width: 200
      }
    ];
    this.columnDefsE2B = [
      {
        headerName: 'Action',
        headerTooltip: 'Action',
        filter: false,
        cellRenderer: 'resumeLoadRenderer',
        cellRendererParams: {
          resumeLoadButton: this.runFile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Run Instance',
        headerTooltip: 'Run Instance',
        tooltipValueGetter: (params) => 'Run Instance : ' + params.value,
        field: 'runInstance',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Type',
        headerTooltip: 'Type',
        tooltipValueGetter: (params) => 'Type : ' + params.value,
        field: 'activity',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Object Name',
        headerTooltip: 'Object Name',
        tooltipValueGetter: (params) => 'Object Name : ' + params.value,
        field: 'objectName',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Task',
        headerTooltip: 'Task',
        tooltipValueGetter: (params) => 'Task : ' + params.value,
        field: 'operation',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'File',
        headerTooltip: 'File Name',
        tooltipValueGetter: (params) => 'File Name : ' + params.value,
        field: 'file',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Start Date and Time',
        headerTooltip: 'Start Date and Time',
        tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value,
        field: 'startdt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'End Date and Time',
        headerTooltip: 'End Date and Time',
        tooltipValueGetter: (params) => 'End Date and Time : ' + params.value,
        field: 'enddt',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) => 'Status : ' + params.value,
        field: 'state',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Success Count',
        headerTooltip: 'Success Count',
        tooltipValueGetter: (params) => 'Success Count : ' + params.value,
        field: 'successcount',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Fail Count',
        headerTooltip: 'Fail Count',
        tooltipValueGetter: (params) => 'Fail Count : ' + params.value,
        field: 'failcount',
        filter: 'agTextColumnFilter',
        width: 120
      },
      {
        headerName: 'Success Log', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.docdownloadSuccess.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },

      {
        headerName: 'Failure Log', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          docdownload: this.docdownloadFailure.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
      {
        headerName: 'Validation Report', filter: false, cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          // docdownload: this.zipdownloadSourceFile.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 120
      },
    ];

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
      enableCellChangeFlash: true
    };

    this.rowSelectionForTablesFields = "single",
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.retrieveMigrationLog();
    this.retrieveetobStageFilePath();
    this.retrieveLiteratureStageFilePath();
    this.retrieveAttachmentStageFilePath();
    this.retrieveetobFTPPath();
    this.retrieveLiteratureFTPPath();
    this.retrieveAttachmentFTPPath();

  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      e2bstageFiles: new UntypedFormControl(this.etobMigrationDetails.e2bstageFiles),
      e2bftpPath: new UntypedFormControl(this.etobMigrationDetails.e2bftpPath),
      literaturestageFiles: new UntypedFormControl(this.etobMigrationDetails.literaturestageFiles),
      literatureftpPath: new UntypedFormControl(this.etobMigrationDetails.literatureftpPath),
      attachmentstageFiles: new UntypedFormControl(this.etobMigrationDetails.attachmentstageFiles),
      attachmentftpPath: new UntypedFormControl(this.etobMigrationDetails.attachmentftpPath),
      attachmentmappingFile: new UntypedFormControl(""),
      imageupload: new UntypedFormControl(""),
      isCheckboxSelected: new UntypedFormControl("")
    });
  }

  //excel export function
  onBtExport() {
    this.gridApi.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi) {
      this.lastPage = this.gridApi.paginationIsLastPageFound();
      this.currentPage = this.gridApi.paginationGetCurrentPage() + 1
      this.nextPage = this.gridApi.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridApi.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridApi.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;
    this.gridApi.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridApi.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridApi.paginationGoToLastPage();
  }
  //pagination code ends

  startMigration(){
    // Change request for comment field. sending dnsId, migrationType and comment in JSON. Changes made by kalpesh
    let startPrompt:any = prompt("Please add comment to start the migration process.");
    if(startPrompt.length == 0){
      this.snackbar.open("Please add comment to start migration process.", "OK", { duration: 5000 });
    }
    else if(startPrompt.length < 15 || startPrompt.length > 100){
      this.snackbar.open("Please add valid comment. Comment length should be between 15 to 100 characters", "OK", { duration: 5000 });
    }else{
      console.log(startPrompt);
      let startmigrationData = {
        "dnsId": this.localStorageSettings.getSettings("dnsName"),
        "migrationType": this.migrationType,
        "comment": startPrompt
      }
      this.spinner.start();
      console.log(startmigrationData);
      this.service.startmigration(startmigrationData).subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.spinner.stop();
        }else{
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.spinner.stop();
          this.retrieveMigrationLog();
        }
      })
  }
  }

  abortMigration(){
    if(confirm("This action will abort migration process.Are you sure you want to continue?")){
      this.spinner.start();
      this.service.abortmigration(this.localStorageSettings.getSettings("dnsName"), this.migrationType,"Aborted",2).subscribe(res=>{
        console.log(res);
        if(res.error===true){
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.spinner.stop();
        }else{
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          this.spinner.stop();
          this.retrieveMigrationLog();
        }
      })
    }
  }

  retrieveMigrationLog(){
    this.spinner.start();
    this.service.retrieveMigrationDatalog(this.localStorageSettings.getSettings("dnsName")).subscribe(response => {

      console.log(response)

      if (response.error == true) {

        this.snackbar.open(response.statusMessage, "Ok", { duration: 5000 });

        this.spinner.stop();

      }

      else {

        this.migrationDataLoadLogObject = response;

        console.log(this.migrationDataLoadLogObject);

        this.mgrstatus = "";
        this.mgrstartdt = "";
        this.mgrid = "";

          for(let i=0;i<this.migrationDataLoadLogObject.length;i++){
            if(this.migrationDataLoadLogObject[i].state === "In Progress"){
              this.mgrstatus = this.migrationDataLoadLogObject[i].state;
              this.mgrstartdt = this.migrationDataLoadLogObject[i].startdt;
              this.mgrid = this.migrationDataLoadLogObject[i].migrationId;
              console.log(this.migrationDataLoadLogObject);
            }
            if(this.mgrstatus != "In Progress"){
              this.mgrstatus = "Migration is not in progress";
            }

        }

        this.spinner.stop();

      }

    });
  }

  refresh(){
    this.spinner.start();
    this.onGridE2Bmigration(this.tempextractparams);
    this.spinner.stop();
  }

  retrieveetobStageFilePath(){
    this.service.retrieveetobStageFilePath().subscribe(response => {
      console.log(response)
      this.etoSTageFilePath = response;
      console.log(this.etoSTageFilePath);
      this.etobMigrationDetails.e2bstageFiles= this.etoSTageFilePath[0].lookupvalue;
    });
  }

  retrieveetobFTPPath(){
    this.service.retrieveetobFTPPath().subscribe(response => {
      console.log(response)
      this.etoFTPPath = response;
      console.log(this.etoFTPPath);
      this.etobMigrationDetails.e2bftpPath= this.etoFTPPath[0].lookupvalue;
    });
  }

  retrieveLiteratureStageFilePath(){
    this.service.retrieveLiteratureStageFilePath().subscribe(response => {
      console.log(response)
      this.literatureSTageFilePath = response;
      console.log(this.literatureSTageFilePath);
      this.etobMigrationDetails.literaturestageFiles= this.literatureSTageFilePath[0].lookupvalue;
    });
  }

  retrieveLiteratureFTPPath(){
    this.service.retrieveLiteratureFTPPath().subscribe(response => {
      console.log(response)
      this.literatureFTPPath = response;
      console.log(this.literatureFTPPath);
      this.etobMigrationDetails.literatureftpPath= this.literatureFTPPath[0].lookupvalue;
    });
  }

  retrieveAttachmentStageFilePath(){
    this.service.retrieveAttachmentStageFilePath().subscribe(response => {
      console.log(response)
      this.attachmentSTageFilePath = response;
      console.log(this.attachmentSTageFilePath);
      this.etobMigrationDetails.attachmentstageFiles= this.attachmentSTageFilePath[0].lookupvalue;
    });
  }

  retrieveAttachmentFTPPath(){
    this.service.retrieveAttachmentFTPPath().subscribe(response => {
      console.log(response)
      this.attachmentFTPPath = response;
      console.log(this.attachmentFTPPath);
      this.etobMigrationDetails.attachmentftpPath= this.attachmentFTPPath[0].lookupvalue;
    });
  }

  readThisimage(inputValue: any,filecheck:any): void {
    let ischeckfile=false
   var file: File = inputValue.files[0];
   var FileS: File = inputValue.files[0];
   console.log(file.type)
   let flag:boolean= this.commonTs.hasMultipleExtensions(file);
   if(filecheck==='csv'){
     if (file.type === 'text/csv' || file.type ==='application/vnd.ms-excel'){
       ischeckfile=true
     }
   }
   if (!flag&&ischeckfile) {

     console.log(file.size / 1000)
     var size = file.size / 1000
     if (size <= 25072) {
           var fileName = FileS.name;
           //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

           var photo: FileReader = new FileReader();
            photo.onloadend = e => {
             var img = photo.result;
             console.log(photo.result);
             var photobase64result = photo.result.toString().split(",", 2)[1];

             // this is to check the file is empty or not
               this.imagephoto = photo.result.toString();
               this.imagephotoshow = true;
               this.statevaluechange.fileData = photobase64result;
               this.statevaluechange.fileName = fileName;
               this.FormValid.controls.attachmentmappingFile.setValue(fileName);
               console.log(this.statevaluechange)
               // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;

           };
               photo.readAsDataURL(file);
     } else {
       this.snackbar.open("Selected image " + file.name + ", size should be less than 3MB", "OK", {
         duration: 5000,
       });
     }
   } else {
     this.snackbar.open(file.name + " is invalid file. Please select CSV file ", "OK", {

       duration: 5000,
     });
   }
 }

 generateReport(e){
    console.log(e);
  }

 runFile(e){
  console.log(e);
  if(confirm("Initiating Run, Are you sure you want to continue?")){
    let setid = e.rowData.setid
    let data={
      "dnsId":this.localStorageSettings.getSettings("dnsName"),
      "migrationId":e.rowData.migrationid,
      "migrationTraceId":e.rowData.migrationtraceid,
      "dnsName":this.localStorageSettings.getSettings("vaultDnsname"),
      "setId":e.rowData.setid,
      "migrationType":e.rowData.activity,
      "objectName":e.rowData.objectName
    }
    console.log(data);
    this.spinner.start();
      this.service.runE2BMigration(data).subscribe(res=>{
        console.log(res);
        this.spinner.stop();
        this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        setid="";
      })
      this.spinner.stop();
    }
}

  attachmentMappingFile($event,filecheck): void {
    this.readThisimage($event.target,filecheck);
  }

  successDoc
  docdownloadSuccess(e){
  console.log(e.rowData)
  this.successDoc = e.rowData.csvDownloadPathSuccess
  if(this.successDoc===undefined || this.successDoc=== "" || this.successDoc ===null){
    this.snackbar.open("Please Wait till the process is completed.", "OK", {
      panelClass: 'snack'
    });
  }else{
    this.spinner.start();
    console.log(this.successDoc+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/success/failure")
  this.service.download_test(this.successDoc+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/success/failure")
    .subscribe(x => {
      console.log(x);
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x]);

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
      link.href = data;
      link.download = e.rowData.objectName+".csv";
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
    }
  }

  failureDoc
  docdownloadFailure(e){
  console.log(e.rowData)
  this.failureDoc = e.rowData.csvDownloadPathFailure
  if(this.failureDoc===undefined || this.failureDoc=== "" || this.failureDoc ===null){
    this.snackbar.open("Please Wait till the process is completed.", "OK", {
      panelClass: 'snack'
    });
  }else{
    this.spinner.start();
  this.service.download_test(this.failureDoc+"/"+this.localStorageSettings.getSettings("vaultDnsname")+"/success/failure")
    .subscribe(x => {
      console.log(x);
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x]);

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
      link.href = data;
      link.download = e.rowData.objectName+".csv";
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
    }
  }

  uploadFile(){
    if(!this.FormValid.valid){
      this.snackbar.open("Please select CSV file", "OK", {duration: 5000});
      this.formvalidations();
    }
    else{
      let mappingfile = {
        "file":this.statevaluechange.fileData,
        "fileName":this.statevaluechange.fileName,
      }
      this.spinner.start();
      console.log(this.statevaluechange);
      this.service.insertetobmappingfile(this.localStorageSettings.getSettings("vaultDnsname"),this.statevaluechange).subscribe(response =>{
        console.log(response);
        // checking if response is true or not
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });

        } else {
          this.spinner.stop();
          console.log(response)
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
        }
        this.spinner.stop();
      });
      this.formvalidations();
    }
  }
  loadFile(){
    let width = "45%";
    let dialogRef = this.dialog.open(EtobPopupComponent, {
      maxWidth: '100vw',
      height: "65%",
      width: width,
      data:{},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      console.log(result);
      this.refresh();

    });
  }

  onGridReadymigration(params){
    this.gridmgrnAPI = params.api;
    this.temprunHistory = params;
    this.gridmgrnData=[];
    this.gridmgrnAPI.setGridOption('rowData', [])
    this.spinner.start();
    this.service.retrieveMigrationDatalog(this.localStorageSettings.getSettings("dnsName")).subscribe((val) => {
      console.log(val);
      this.gridmgrnData = val;
      if(this.gridmgrnData.length ===0){
        this.gridmgrnAPI.setGridOption('rowData', [])
      }else{
        this.tempdata=[];
        this.tempmgrndata=[];
       for(let i=0;i<this.gridmgrnData.length;i++){
         this.tempdata = this.gridmgrnData[i];
         this.tempmgrndata.push(this.tempdata);
       }
       console.log(this.tempmgrndata)
       this.gridmgrnAPI.setGridOption('rowData', this.tempmgrndata);
      }
    });
    this.spinner.stop();
  }

  cellClickedObjects(event){
    // this.spinner.start();
    console.log(event.data.migrationId);
    this.migrationParentId = event.data.migrationId;
    console.log(this.migrationParentId)
    this.onGridE2Bmigration(this.tempextractparams);
    // this.spinner.stop();
  }


  onGridE2Bmigration(params){
    this.gridData=[];
    this.tempextractparams = params
    this.gridApi = params.api;
    this.gridApi.setGridOption('rowData', [])
    this.spinner.start();
    if (
      this.localStorageSettings.getSettings("dnsName") &&
      this.migrationParentId !== null &&
      this.migrationType !== null &&
      typeof this.migrationParentId !== "undefined" &&
      typeof this.migrationType !== "undefined"
    ){
    this.service.retrieveMigrationExtracttrace(this.localStorageSettings.getSettings("dnsName"),this.migrationParentId,this.migrationType).subscribe((val) => {
      console.log(this.localStorageSettings.getSettings("dnsName"));
      console.log(val)
      this.gridData = val;
      if(this.gridData.length ===0){
        this.gridApi.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        this.tempmgrdata=[];
        this.migrationData=[];
        for(let i=0;i<this.gridData.length;i++){
          console.log(this.migrationParentId);
          console.log(this.gridData[i].migrationid);
           if(this.gridData[i].migrationid == this.migrationParentId){
            console.log(this.migrationParentId + "2");
            this.gridData[i].setName = this.gridData[i].setid;
            this.gridData[i].runInstance = "Run_"+this.gridData[i].migrationid
            this.tempmgrdata = this.gridData[i];
            this.migrationData.push(this.tempmgrdata);
         }
       }
       console.log(this.migrationData);
      this.gridApi.setGridOption('rowData', this.migrationData)
      }

    });
    this.spinner.stop();
  }

  }
}
